import { useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';

import ForgotPasswordCard from './sections/ForgotPasswordCard/ForgotPasswordCard';
import Footer from '../../../shared/components/Globals/Footer/Footer';
import Toast from '../../../shared/components/Globals/Toast/Toast';
import { LOGIN_ROUTE } from '../../../shared/constants/auth';
import { GENERIC_ERROR_TOAST } from '../../../shared/constants/toast';
import { AuthContext } from '../../../shared/hooks/useAuth/useAuth';

const ForgotPassword = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { email?: string } | null;
  const email = state?.email || '';

  const { t } = useTranslation();

  const { errorCode, resetError } = useContext(AuthContext);

  const errorToast = Boolean(errorCode);

  useEffect(() => {
    if (!email) {
      navigate(LOGIN_ROUTE);
    }
  }, [email, navigate]);

  return (
    <>
      <div className="auth__container">
        <ForgotPasswordCard email={email} />
      </div>
      <Footer />
      <Toast
        message={t(GENERIC_ERROR_TOAST.message)}
        variant={GENERIC_ERROR_TOAST.variant}
        open={errorToast}
        onClose={() => resetError('')}
      />
    </>
  );
};

export default ForgotPassword;
